import React, { useState, useEffect } from 'react';
import { Box, Text, Flex, DataList, Avatar, Badge, Button, Dialog, AlertDialog, Spinner, TextField } from '@radix-ui/themes';
import { DateTime } from 'luxon';
import UserAvatar from '../common/UserAvatar';
import usePaystackUpgrade from '../../hooks/usePaystackUpgrade';
import GuardianLinkTeacher from './GuardianLinkTeacher';
import EmailUpdateForm from '../forms/EmailUpdateForm';
import { useSelector } from 'react-redux';
import ConfirmPaymentDialog from '../../components/ConfirmPaymentDialog';
import { toast } from 'react-toastify'
import api from '../../api';
import { subscriptionService } from '../../services/subscriptionService';
import { Cross2Icon } from '@radix-ui/react-icons';
import { updateStudents } from '../../redux/slices/guardianSlice';
import { useDispatch } from 'react-redux';

const WardDetails = ({ studentDetails, view }) => {
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [showChangeSubscriptionDialog, setShowChangeSubscriptionDialog] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [teacherCourses, setTeacherCourses] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoadingCourses, setIsLoadingCourses] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const {
    upgradeStudent,
    showEmailDialog,
    setShowEmailDialog,
    showConfirmPaymentDialog,
    setShowConfirmPaymentDialog,
    baseAmount,
    discountCode,
    setDiscountCode,
    isLoading,
    applyDiscountCode,
    handleConfirmPaymentOpenChange,
    selectedDuration,
    setSelectedDuration,
  } = usePaystackUpgrade();
  const user = useSelector(state => state.user);
  const guardian = useSelector((state) => state.guardian);

  console.log('baseAmountxxccd::', baseAmount);

  const handleUpgradeClick = (e) => {
    e.preventDefault();
    upgradeStudent({ ...studentDetails, payerType: 'guardian' });
  };


  // Fetch teachers based on search query
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchQuery.length < 2) {
        setTeachers([]);
        return;
      }
      setIsSearching(true);
      try {
        const response = await api.get(`/teachers?search=${encodeURIComponent(searchQuery)}`);
        setTeachers(response.data.teachers || []);
        setError(null);
      } catch (err) {
        setError('Failed to fetch teachers. Please try again.');
      } finally {
        setIsSearching(false);
      }
    }, 500); // Debounce for 500ms

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  // Fetch courses for selected teacher
  useEffect(() => {
    if (!selectedTeacher) {
      setTeacherCourses([]);
      return;
    }
    const fetchCourses = async () => {
      setIsLoadingCourses(true);
      try {
        const response = await api.get(`/teachers/${selectedTeacher.id}/courses?level_id=${studentDetails.current_level.id}`);
        setTeacherCourses(response.data.courses || []);
        setError(null);
      } catch (err) {
        setError('Failed to fetch courses. Please try again.');
      } finally {
        setIsLoadingCourses(false);
      }
    };
    fetchCourses();
  }, [selectedTeacher]);

  const handleCourseToggle = (course) => {
    setSelectedCourses((prev) => {
      const exists = prev.find((c) => c.id === course.id);
      if (exists) {
        return prev.filter((c) => c.id !== course.id);
      }
      return [...prev, course];
    });
  };

  const handleSubscribeAll = async () => {
    try {
      const levelId = studentDetails.current_level?.id;
      if (!levelId) {
        throw new Error('Student level not found.');
      }
      const updated_subscription = await subscriptionService.updateAllWardSubscriptions(studentDetails.id, selectedTeacher.id, levelId);

      dispatch(updateStudents(updated_subscription.students));
      setShowChangeSubscriptionDialog(false);
      setSelectedTeacher(null);
      setSearchQuery('');
      setSelectedCourses([]);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to subscribe to all courses.');
    }
  };

  const handleSaveSelected = async () => {
    try {
      if (selectedCourses.length === 0) {
        throw new Error('No courses selected.');
      }
      const subscriptions = selectedCourses.map((course) => ({
        subject_id: course.subject.id,
        course_id: course.id,
      }));
      const updated_subscription = await subscriptionService.updateSelectedWardSubscriptions(studentDetails.id, subscriptions);

      dispatch(updateStudents(updated_subscription.students));
      setShowChangeSubscriptionDialog(false);
      setSelectedTeacher(null);
      setSearchQuery('');
      setSelectedCourses([]);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to update selected subscriptions.');
    }
  };

  const handleCourseSelect = async (course) => {

    try {
      const updated_subscription = await subscriptionService.updateWardSubscription(studentDetails.id, course.subject_id, course.id);
      console.log('updated_subscription>>>>>>>>>>>>>>', updated_subscription);
      toast.success(updated_subscription.message);


      dispatch(updateStudents(updated_subscription.students));

      // Optionally, refresh studentDetails or update local state
      setShowChangeSubscriptionDialog(false);
      setSelectedTeacher(null);
      setSearchQuery('');
      setError(null);
    } catch (err) {
      setError('Failed to update subscription');
      console.error(err);
    }
  };


  return (
    <Box>
      {view === 'school' && (
        <Box>
          <DataList.Root>
            <DataList.Item>
              <DataList.Label>School</DataList.Label>
              <DataList.Value>{studentDetails.school?.name}</DataList.Value>
            </DataList.Item>
            <DataList.Item>
              <DataList.Label>Class</DataList.Label>
              <DataList.Value>{studentDetails.current_level.label}</DataList.Value>
            </DataList.Item>
          </DataList.Root>
        </Box>
      )}
      {view === 'class' && (
        <Box>
          <Flex direction="row" width="100%" gap="2" align="start" style={{ flexWrap: 'wrap' }}>
            {studentDetails.subscriptions.map((subscription) => (
              <Flex
                direction="row"
                key={subscription.id}
                gap="1"
                width="45%"
                align="center"
                className='cursor-pointer'
                style={{ border: '1px solid #e0e0e0', padding: '5px', borderRadius: '5px' }}
                onClick={() => setCurrentSubscription(subscription)}
              >
                {subscription.course ? (
                  <>
                    <UserAvatar user={subscription.course.teacher?.user} />
                    <Box>
                      <Text size="1" weight="bold" as="p">{subscription.course.subject.name}</Text>
                      <Text size="1" as="p">{subscription.course.teacher?.user?.firstname} {subscription.course.teacher?.user?.lastname}</Text>
                    </Box>
                  </>
                ) : (
                  subscription.ai_course && (
                    <>
                      <Avatar size="2" fallback="AI" color="orange" />
                      <Text size="1" weight="bold" as="p">{subscription.ai_course.subject.name}</Text>
                    </>
                  )
                )}
              </Flex>
            ))}
          </Flex>


          <Badge color="gray" size="1" weight="bold" as="p" mt="2">
            {studentDetails.subscriptions.filter(sub => sub.course).length}/ 10 subjects
          </Badge>
          <div className="mt-2">
            <Button
              mt="2"
              mb="3"
              onClick={() => setShowChangeSubscriptionDialog(true)}
              variant="soft"
            >
              Update Subscription
            </Button>
          </div>
        </Box>
      )}
      {view === 'account' && (
        <Flex direction="row" width="100%" gap="2" align="start" style={{ flexWrap: 'wrap' }}>
          <Box>
            <Text mb="4" size="1" weight="bold" as="p">Payment Details</Text>
            {studentDetails?.payment_details?.status === 'active' &&
              studentDetails?.payment_details?.details?.end_date &&
              DateTime.fromISO(studentDetails.payment_details.details.end_date) > DateTime.now() ? (
              <Box>
                <Text size="3" as="p">Paid at: {DateTime.fromISO(studentDetails.payment_details.details.created_at).toFormat('DD')}</Text>
                <Text size="3" as="p">Expires: {DateTime.fromISO(studentDetails.payment_details.details.end_date).toFormat('DD')}</Text>

                <Button
                  mt="2"
                  mb="3"
                  onClick={handleUpgradeClick}
                  color={`${studentDetails?.payment_details?.disable_payment ? 'gray' : 'green'}`}
                  disabled={isLoading || studentDetails?.payment_details?.disable_payment}
                >
                  {studentDetails?.payment_details?.disable_payment ? 'Already subscribed' : (isLoading ? 'Processing...' : 'Renew Subscription')}
                </Button>
              </Box>
            ) : (
              <Box>
                <Button
                  mb="3"
                  onClick={handleUpgradeClick}
                  color='green'
                  disabled={isLoading}
                >
                  {isLoading ? 'Processing...' : 'Upgrade'}
                </Button>
                <ul className="list-disc pl-4 mt-1 space-y-1">
                  <li>All Subjects</li>
                  <li>50 questions daily for wards</li>
                  <li>Analytics for all your wards</li>
                </ul>
              </Box>
            )}
          </Box>
        </Flex>
      )}
      <Dialog.Root>
        <Dialog.Content>
          <Dialog.Title>Link Teacher</Dialog.Title>
          <Dialog.Description>Provide the teacher's handle to link to their course</Dialog.Description>
          <GuardianLinkTeacher studentId={studentDetails.id} />
        </Dialog.Content>
      </Dialog.Root>


      <AlertDialog.Root open={showEmailDialog} onOpenChange={setShowEmailDialog}>
        <AlertDialog.Content className="p-4 rounded shadow-lg w-1/3 mx-auto">
          <AlertDialog.Title>Update Email Address</AlertDialog.Title>
          <AlertDialog.Description>
            Please provide an email address to continue with the payment.
          </AlertDialog.Description>
          <div className="mt-4">
            <EmailUpdateForm setShowEmailDialog={setShowEmailDialog} />
          </div>
        </AlertDialog.Content>
      </AlertDialog.Root>

      <AlertDialog.Root open={showChangeSubscriptionDialog} onOpenChange={setShowChangeSubscriptionDialog}>
        <AlertDialog.Content className="p-4 rounded shadow-lg w-full max-w-md mx-auto relative">
          {/* <AlertDialog.Close asChild> */}
          <Button
            variant="ghost"
            size="1"
            style={{ position: 'absolute', top: '8px', right: '8px' }}
            aria-label="Close dialog"
            onClick={() => {
              setSelectedTeacher(null);
              setSearchQuery('');
              setSelectedCourses([]);
              setShowChangeSubscriptionDialog(false);
            }}
          >
            <Cross2Icon />
          </Button>
          {/* </AlertDialog.Close> */}
          <AlertDialog.Title>Change Subscription</AlertDialog.Title>
          <AlertDialog.Description>Search for a teacher to view their courses.</AlertDialog.Description>
          <TextField.Root
            placeholder="Search teachers..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mt-4"
            disabled={isSearching}
          />
          {isSearching && (
            <Flex justify="center" mt="2">
              <Spinner size="2" />
            </Flex>
          )}
          {teachers.length > 0 && !selectedTeacher && (
            <Box mt="4" style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {teachers.map((teacher) => (
                <Flex
                  key={teacher.id}
                  direction="row"
                  gap="2"
                  align="center"
                  role="button"
                  aria-label={`Select teacher ${teacher.firstname} ${teacher.lastname}`}
                  style={{ padding: '8px', borderBottom: '1px solid #e0e0e0', cursor: 'pointer' }}
                  onClick={() => setSelectedTeacher(teacher)}
                  onKeyDown={(e) => e.key === 'Enter' && setSelectedTeacher(teacher)}
                  tabIndex={0}
                >
                  <UserAvatar user={teacher} />
                  <Text size="2">
                    {teacher.firstname} {teacher.lastname}
                  </Text>
                </Flex>
              ))}
            </Box>
          )}
          {selectedTeacher && (
            <Box mt="4">
              <Flex direction="row" gap="2" mb="2">
                <Button
                  variant="ghost"
                  size="1"
                  onClick={() => {
                    setSelectedTeacher(null);
                    setSelectedCourses([]);
                  }}
                >
                  Back to Teachers
                </Button>
              </Flex>
              <Text size="2" weight="bold" as="p">
                Courses by {selectedTeacher.firstname} {selectedTeacher.lastname}
              </Text>
              {isLoadingCourses ? (
                <Flex justify="center" mt="2">
                  <Spinner size="2" />
                </Flex>
              ) : teacherCourses.length > 0 ? (
                <>
                  <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {teacherCourses.map((course) => {
                      const isSelected = selectedCourses.find((c) => c.id === course.id);
                      return (
                        <Flex
                          key={course.id}
                          direction="row"
                          gap="2"
                          align="center"
                          role="button"
                          aria-label={`Select course ${course.subject.name}`}
                          style={{
                            padding: '8px',
                            border: `2px solid ${isSelected ? '#2196F3' : '#E0E0E0'}`,
                            borderRadius: '4px',
                            cursor: 'pointer',
                            marginBottom: '4px',
                          }}
                          onClick={() => handleCourseToggle(course)}
                          onKeyDown={(e) => e.key === 'Enter' && handleCourseToggle(course)}
                          tabIndex={0}
                        >
                          <Text size="2">{course.subject.name}</Text>
                        </Flex>
                      );
                    })}
                  </Box>


                  <div className='flex justify-between mt-4'>
                    <Button
                      variant="solid"
                      color="blue"
                      size="2"
                      onClick={handleSaveSelected}
                      disabled={selectedCourses.length === 0}
                    >
                      Save Selected Courses
                    </Button>


                    <Button
                      variant="solid"
                      color="green"
                      size="2"
                      onClick={handleSubscribeAll}
                      disabled={isLoadingCourses || teacherCourses.length === 0}
                    >
                      Subscribe to All Courses
                    </Button>
                  </div>

                </>
              ) : (
                <Text size="2" color="gray">
                  No courses available for this teacher.
                </Text>
              )}
            </Box>
          )}
        </AlertDialog.Content>
      </AlertDialog.Root>

      <ConfirmPaymentDialog
        showConfirmPaymentDialog={showConfirmPaymentDialog}
        setShowConfirmPaymentDialog={setShowConfirmPaymentDialog}
        discountCode={discountCode}
        setDiscountCode={setDiscountCode}
        isLoading={isLoading}
        applyDiscountCode={applyDiscountCode}
        handleDiscountOpenChange={handleConfirmPaymentOpenChange}
        selectedDuration={selectedDuration}
        setSelectedDuration={setSelectedDuration}
        baseAmount={baseAmount || 4000}
      />
    </Box>
  );
};

export default WardDetails;